import { svgEditServiceInstance } from "@/services/svg-edit-service";

/**
 * Used to store the current state of the user's input
 */
export class InputState {
    public spaceKeyDown: boolean;
    public actionStarted: boolean;

    public getStarted() {
        return this.actionStarted;
    }

    public setStarted(newValue: boolean) {
        this.actionStarted = newValue;
        svgEditServiceInstance.ElementStateHasChanged();
    }
}